// removed by extract-text-webpack-plugin
module.exports = {"background-grey":"#f6f6f6","grey":"#707070","black":"#000000","orange":"#ef8d07","top-banner-height":"225px","app-grey":"#f5f6fa","banner":"aSl6VD2lvRZYURXQZ7grq","mainWrapper":"_1rotlaa1yjudmPlxBNSWjE","subtitle":"_375tkXZTkD8mHuYhi-m4g","title":"_1Ew2bkq2nNzaWVlBPe-s05","toggleContainer":"_2qIHV-DaJrCQBSV8wWHk0C","bulb":"_1F9rkdB8_ssH9SJFeHCukk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopBanner/TopBanner.css
// module id = 1601
// module chunks = 0